<script>
import _isEmpty from "lodash/isEmpty";

export default {
  computed: {
    currentAccount() {
      return this.$store.state.account.currentAccount;
    },
    accounts() {
      return this.$store.state.account.accounts;
    }
  },

  data() {
    return {
      loading: true
    };
  },

  mounted() {
    if (_isEmpty(this.currentAccount) || _isEmpty(this.accounts)) {
      this.fetch();
    } else {
      this.loading = false;
    }
  },

  methods: {
    async fetch() {
      try {
        this.$store.dispatch("account/getAccountsByUser");
        await this.$store.dispatch("account/getCurrentAccount");

        this.loading = false;
      } catch (error) {
        this.$toasted.global.error();
      }
    }
  },

  render: function(createElement) {
    return this.$scopedSlots.default({
      currentAccount: this.currentAccount,
      loading: this.loading,
      accounts: this.accounts
    });
  }
};
</script>